import ListProducts from './ListProducts';
import NewProductModal from './NewProductModal';
import ViewProduct from './ViewProduct';

window.Vue.component('MerchantListProducts', ListProducts);
window.Vue.component('MerchantNewProductModal', NewProductModal);
window.Vue.component('MerchantViewProduct', ViewProduct);